module.exports = __webpack_public_path__ + "static/logo-e4eb98577d5832a8c2c2e2a6cfc50036.png";